import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ContactList } from "@/components/features-new/contact/top";

import { useContactTopPageParams } from "./hooks";

export const ContactTopPage = () => {
	const { hotelID } = useContactTopPageParams();

	return (
		<PageMeta title="お問い合わせ一覧" url={generatePath(PATHS.HOTEL.CONTACT.TOP, { hotelID })}>
			<ContactList hotelID={hotelID} />
		</PageMeta>
	);
};

ContactTopPage.displayName = "ContactTopPage";
